import React, { useState } from "react";
import ClientePage from "./ClientePage";
import ClientesLista from "./ClientesLista";

/* "Clientes" del módulo Turnos Beauty: la lista y, al abrir un cliente, su ficha.
   La lista queda montada (oculta) para conservar la búsqueda y la página; al volver se recarga.
   `barra(fichaAbierta, cerrarFicha)` deja que la pantalla dueña ponga una sola barra de "Volver" para la lista
   y la ficha; sin ella, la ficha muestra su propio botón. */

const ClientesTab = ({ barra }) => {
  const [abierto, setAbierto] = useState(null);
  const [version, setVersion] = useState(0);
  const cerrar = () => {
    setVersion((n) => n + 1);
    setAbierto(null);
  };

  return (
    <>
      {barra?.(Boolean(abierto), cerrar)}
      <div hidden={Boolean(abierto)}>
        <ClientesLista onAbrir={setAbierto} refreshKey={version} />
      </div>
      {abierto && (
        <ClientePage
          key={abierto}
          clientId={abierto}
          onVolver={cerrar}
          onArchivado={cerrar}
          {...(barra ? { volverLabel: null } : {})}
        />
      )}
    </>
  );
};

export default ClientesTab;
